module.exports = __webpack_public_path__ + "img/mkarczmarczyk.ac9cca8a.jpg";